import React from "react";
import { ProgressOverlay } from "./ProgressOverlay";

interface SaveProgressOverlayProps {
  isOpen: boolean;
  currentTask: string | null;
}

export function SaveProgressOverlay({
  isOpen,
  currentTask,
}: SaveProgressOverlayProps) {
  return (
    <ProgressOverlay
      isOpen={isOpen}
      title="正在保存..."
      currentTask={currentTask}
    />
  );
}

